export default "/collab-coin.c07cac0e7fbe9e215c56ed37cc15f25c.svg";